<template>
  <div>
        <template v-if="merchantPayments === null || merchantPayments === true">
            <div v-show="merchantPayments === null"><preLoader></preLoader></div>
            <div v-show="merchantPayments != null"> 
                <div class="modal fade" id="sendToCheckerPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body send-to-checker-popup text-center p-4">
                                <span class="exclamation-outer">
                                    <i class="fas fa-exclamation"></i>
                                </span>
                                <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                                <button type="button" class="btn btn-primary" @click="sendtochecker()">Yes</button>
                                <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="sendToApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body send-to-checker-popup text-center p-4">
                                <span class="exclamation-outer">
                                    <i class="fas fa-exclamation"></i>
                                </span>
                                <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                                <button type="button" class="btn btn-primary" @click="sendToApprover();">Yes</button>
                                <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix">
                    <div class="page-top dropdown mb-1 mb-3 clearfix" v-if="sheet != null">
                        <h1 class="float-left"> {{sheet.name}} <span class="highlight-color"> ({{sheet.payroll_amount}} PKR) </span> </h1>
                        <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "sendToCheckerPopup()" v-if="merchantPaymentSendToChecker === true && sheet.status === 1"> Send To Checker </a>
                        <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToApprover" @click = "sendToApproverPopup()" v-if="merchantPaymentSendToApprover === true && sheet.status == 2"> Send To Approver </a>
                        <div class="head-date float-right mr-2"> {{sheet.created_at | date_format}} <i class="fas fa-calendar-alt"></i> </div>
                    </div>
                    <div class="batch-history mb-3 clearfix" v-if="history != null && history.length > 0">
                        <h2> <span class="text"> Batch History </span> </h2>
                        <ul class="batch-status-list">
                            <li class="status-list-item" v-for="his in history" v-bind:value="his.id" v-bind:key="his.id">
                                <span class="status uploaded" v-if="his.action == 'UPLOAD'"> Uploaded </span>
                                <span class="status flagged" v-if="his.action == 'FLAGGED'"> Flagged </span>
                                <span class="status flagged" v-if="his.action == 'UNDERREVIEW'"> Under Review </span>
                                <span class="status rejected" v-if="his.action == 'DISAPPROVED'"> Rejected </span>
                                <span class="status checked" v-if="his.action == 'CHECKED'"> Checked </span>
                                <span class="status approved" v-if="his.action == 'APPROVED'"> Approved </span>
                            </li>
                        </ul>
                    </div>
                    <table id="merchantPaymentTable" class="table table-responsive-xl" style="width:100%" v-show="sheet != null">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Reason</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </template>
        <template v-if="merchantPayments == false"><notAllowed></notAllowed></template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                payrollId : this.$route.params.id,
                sheet : null,
                history : null,
                merchantPayments : null,
                merchantPaymentSendToChecker : null,
                merchantPaymentSendToApprover : null,
                merchantPaymentProcess : null
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('merchant_payments|merchant_payment_send_to_checker|merchant_payment_send_to_approver').then(result => {
                this.merchantPayments = result.merchant_payments;
                this.merchantPaymentSendToChecker = result.merchant_payment_send_to_checker;
                this.merchantPaymentSendToApprover = result.merchant_payment_send_to_approver;
            }).then(result => {
                if(this.merchantPayments == true){
                    this.viewMerchantPaymentSheet();
                }
            });
        },
        methods: {
            sendToCheckerPopup(){
                $('#sendToCheckerPopup').modal('show');
            },
            sendToApproverPopup(){
                $('#sendToApproverPopup').modal('show');
            },
            viewMerchantPaymentSheet: function(){
                var that = this;
                var merchantPaymentSheet = $('#merchantPaymentTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "/api/viewMerchantPaymentSheet/"+that.$route.params.id,
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": function ( response ) {
                            that.sheet = response.sheet;
                            that.history = response.history;
                            return response.records;
                        },
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'reason'},
                        {data: 'net_salary'},
                        {data: 'id', sorting: false, visible: true, render: function(data,type,full){
                            if(that.sheet.status < 4){
                                return '--';
                            }else{
                                return '<img src="/images/happy-sm.png" alt="">';
                            }
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
            },
            sendtochecker : function(){
                axios.get('/api/merchantPaymentSendToChecker/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.showToastBox('success','Batch has been checked successfully');
                        $('#sendToCheckerPopup').modal('hide');
                        this.$router.push('/merchantPayments');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                }); 
            },
            sendToApprover : function(){
                axios.get('/api/merchantPaymentSendToApprover/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.showToastBox('success','Batch has been processed successfully');
                        $('#sendToApproverPopup').modal('hide');
                        this.$router.push('/merchantPayments');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                }); 
            }            
        },
        created() {
        }
    }
</script>
